import clsx from 'clsx'

import { AppAdviceText } from 'shared/ui/app-advice-text'
import { Loader as LoaderComponent } from 'shared/ui/loader'

import s from './styles.module.scss'

export const Loader = () => {
  return (
    <div className={clsx('container', s.loader)}>
      <LoaderComponent />

      <AppAdviceText />
    </div>
  )
}
